/**
 * パスワード検証ルール（フロント / サーバー共通）
 * 変更時は server/shared/passwordValidation.js のみ編集すること。
 */

export const PASSWORD_MIN_LENGTH = 8;
export const RE_LETTER = /[a-zA-Z]/;
export const RE_NUMBER = /[0-9]/;
export const RE_SPECIAL = /[!@#$%^&*()_+\-=[\]{}|;:,.<>?]/;

export function validatePassword(password) {
  if (!password || typeof password !== 'string') {
    return { valid: false, message: 'パスワードを入力してください。' };
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    return { valid: false, message: 'パスワードは8文字以上で入力してください。' };
  }
  if (!RE_LETTER.test(password)) {
    return { valid: false, message: 'パスワードに英字を1文字以上含めてください。' };
  }
  if (!RE_NUMBER.test(password)) {
    return { valid: false, message: 'パスワードに数字を1文字以上含めてください。' };
  }
  if (!RE_SPECIAL.test(password)) {
    return { valid: false, message: 'パスワードに記号を1文字以上含めてください。' };
  }
  return { valid: true };
}
